import {
  Box,
  Typography,
  IconButton,
  Button,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

/* ------------------------------------------------------------------ */
/* MOCK DATA */
/* ------------------------------------------------------------------ */

const rows = [
  {
    id: 1,
    name: '2023/24',
    displayName: '2023/24',
    start: 'Fri, August 11th 2023',
    end: 'Sat, May 11th 2024',
  },
  {
    id: 2,
    name: '2024/25',
    displayName: '2024/25',
    start: 'Fri, August 9th 2024',
    end: 'Sat, January 11th 2025',
  },
  {
    id: 3,
    name: 'Season 2025/2026',
    displayName: '2025',
    start: 'Sat, August 9th 2025',
    end: 'Sat, January 10th 2026',
  },
];

/* ------------------------------------------------------------------ */
/* COMPONENT */
/* ------------------------------------------------------------------ */

export default function AdminSeasonsPage() {
  const navigate = useNavigate();
  const { competitionId } = useParams();
  const location = useLocation();

  const competitionName =
    location.state?.competitionName || `Competition ${competitionId}`;

  /* ---------------- HANDLER ---------------- */

  const handleManageFixtures = (row) => {
    navigate(
      `/dashboard/admin-portal/competitions/${competitionId}/seasons/${row.id}/fixtures`,
      {
        state: {
          seasonName: row.name,
        },
      }
    );
  };

  /* ---------------- COLUMNS ---------------- */

  const columns = [
    { field: 'name', headerName: 'NAME', flex: 1 },
    { field: 'displayName', headerName: 'DISPLAY NAME', flex: 1 },
    { field: 'start', headerName: 'START', flex: 1 },
    { field: 'end', headerName: 'END', flex: 1 },
    {
      field: 'actions',
      headerName: 'ACTIONS',
      width: 300,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button size="small" variant="contained" color="info">
            Edit
          </Button>

          <Button
            size="small"
            variant="contained"
            sx={{ backgroundColor: '#7CFFCB', color: '#000' }}
            onClick={() => handleManageFixtures(params.row)}
          >
            Manage Fixtures
          </Button>

          <Button size="small" variant="contained" color="error">
            Delete
          </Button>
        </Box>
      ),
    },
  ];

  return (
    <Box
      sx={{
        border: '1px solid #ffffff',
        borderRadius: 1,
        p: 2,
        backgroundColor: '#1c1c1c',
      }}
    >
      {/* HEADER */}
      <Box sx={{ mb: 2 }}>
        {/* ROW 1: BACK */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <IconButton
            onClick={() => navigate(-1)}
            sx={{ color: '#fff' }}
          >
            <ArrowBackIcon />
          </IconButton>
        </Box>

        {/* ROW 2: TITLE + ADD */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography
            sx={{
              color: '#fff',
              fontSize: 18,
              fontWeight: 600,
            }}
          >
            {competitionName}
          </Typography>

          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            sx={{
              color: '#fff',
              borderColor: '#fff',
              textTransform: 'uppercase',
              fontSize: 12,
            }}
          >
            Add Season
          </Button>
        </Box>
      </Box>

      {/* GRID */}
      <Box sx={{ height: 420 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          disableRowSelectionOnClick
          pageSizeOptions={[10]}
          sx={{
            border: 'none',
            color: '#fff',
            backgroundColor: '#111',

            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#1a1a1a',
              borderBottom: '1px solid #333',
            },
            '& .MuiDataGrid-row': {
              borderBottom: '1px solid #333',
            },
            '& .MuiDataGrid-footerContainer': {
              borderTop: '1px solid #333',
            },
          }}
        />
      </Box>
    </Box>
  );
}
